import { Cart } from '../globals/cart';
import { ENDPOINT } from '../globals/endpoint';
import { Item } from '../globals/item';
import { apiHelper } from '../helpers/api-helper';

export interface SubmitCartResponse {
  status: string;
  items: CartResponseItem[];
  numberOfRecurringPayments: number;
  periodicPayment: number;
  paymentFrequency: string;
  termMonths: number;
  cashPrice: number;
  leaseToOwnTotal: number;
  leaseCostToOwn: number;
  initialPayment: number;
  initialPaymentTax: number;
  totalRetailerFeeAmount: number;
  totalTax: number;
  totalDueAtSigning: number;
  totalRetailerFees: number;
  retailerFeeTax: number;
  retailerDeliveryFeesTax: number;
  totalInitialPayment: number;
  totalRetailerDeliveryFees: number;
  totalRetailerOtherFees: number;
  merchantSubmittedTotalTax: number;
  periodicPaymentWithEstimatedTax: number;
}

export interface CartResponseItem extends Item {
  isLeasable: boolean;
}

export const submitCart = async ({ ...cart }: Partial<Cart>): Promise<SubmitCartResponse | undefined> => {
  const endpoint = ENDPOINT.Cart;

  cart.items?.forEach((item, index, array) => {
    if (!item?.condition) {
      array[index].condition = 'new';
    }
  });

  const response = await apiHelper(endpoint, {
    method: 'POST',
    body: JSON.stringify({ cart }),
  });

  const resp = await response.json();

  return response.ok ? resp : void 0;
};
